<template>
  <div class="tree-select-dropdown-controls">
    <MButton
      link
      gray
      class="tree-select-dropdown-controls__reset"
      @click="$emit('cancel')"
    >
      {{ cancelButtonText }}
    </MButton>
    <MButton
      link
      :disabled="readonly"
      :class="{'tree-select-dropdown-controls__apply--disabled m-button_disabled': disableOkButton.disable}"
      class="tree-select-dropdown-controls__apply"
      @click="submit"
    >
      OK
    </MButton>
  </div>
</template>

<script>
  import getTr from 'translation';
  import MButton from 'components/Inputs/Basic/MButton';

  export default {
    name: 'TreeSelectDropdownControls',
    components: {MButton},
    props: {
      cancelButtonText: {
        type: String,
        default: () => getTr('cancel')
      },
      readonly: {
        type: Boolean,
        default: false
      },
      disableOkButton: {
        type: Object,
        default: () => ({
          disable: false,
          hint: ''
        })
      }
    },
    methods: {
      submit () {
        if (this.disableOkButton.disable) {
          this.$notify({
            layout: 'bar',
            type: 'warning',
            text: this.disableOkButton.hint,
            container: '.notify-container',
            maxVisible: 1
          });
          return;
        }

        this.$emit('submit');
      }
    }
  };
</script>

<style>
  .tree-select-dropdown-controls {
    display: flex;

    align-items: center;

    padding: 0 22px;
  }

  .tree-select-dropdown-controls .m-button {
    font-size: 16px;
  }

  .tree-select-dropdown-controls__reset {
    margin-left: auto;
  }

  .tree-select-dropdown-controls__apply {
    margin-left: 18px;
  }

  .tree-select-dropdown-controls__apply--disabled,
  .tree-select-dropdown-controls__apply--disabled:hover {
    color: var(--action-disabled-color);
    cursor: default;
  }

</style>
